var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { convertPdfToImages, MimeType } from '@mitchell/react.component.ux';
import { FILE_UPLOAD_SINGLE_FILE_UPLOAD_CANCEL, scaleImageCompleteAction, singleFileUploadCompleteAction } from '../../actions';
import { EnterpriseDocStoreService, isJpegImage, processJpegImageExif, PDF_THUMBNAIL } from "../../../common";
import { call, put, race, select, take } from 'redux-saga/effects';
import { getEdsCreateRequestById, getFileInfoById, getFileUploadSuccessHeaderByHeaderKey } from '../../selectors';
import { singleFileUploadProgressSaga } from './singleFileUploadProgressSaga';
import { FileUploadStatus } from '../../enums';
import { ImageScalingService, FileHelperService } from '../../services';
/*istanbul ignore next*/
export function createEdsRequest(request) {
    return __awaiter(this, void 0, void 0, function* () {
        const edsService = new EnterpriseDocStoreService();
        return yield edsService.postCreationRequest(request);
    });
}
/*istanbul ignore next*/
export function createMetadata(request) {
    return __awaiter(this, void 0, void 0, function* () {
        const edsService = new EnterpriseDocStoreService();
        return yield edsService.postFileMetadata(request);
    });
}
export const createMetadataRequest = (fileInfo, edsCreateResponse) => {
    return {
        applicationName: fileInfo.applicationName,
        caller: fileInfo.applicationName,
        correlationId: fileInfo.id,
        createRequestId: edsCreateResponse.requestId,
        documentName: fileInfo.fileName,
        documentSizeInBytes: fileInfo.fileSizeInBytes,
        duplicateDocumentAllowed: fileInfo.isDuplicateDocumentAllowed !== false
    };
};
/*istanbul ignore next*/
export function compressImage(file, scaledMaxSize, maximumImageHeight, maximumImageWidth) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield ImageScalingService.compressImage(file, scaledMaxSize, maximumImageHeight, maximumImageWidth);
    });
}
const edsUpload = function* (fileId, fileInfo, file) {
    const edsCreateRequest = yield select(getEdsCreateRequestById, fileId);
    const edsCreateResponse = yield call(createEdsRequest, edsCreateRequest);
    const { disableProgressNotification } = fileInfo;
    yield call(singleFileUploadProgressSaga, edsCreateResponse.documentUrl, fileId, file, disableProgressNotification);
    const fileMetadataRequest = Object.assign(Object.assign({}, createMetadataRequest(fileInfo, edsCreateResponse)), { md5: yield select(getFileUploadSuccessHeaderByHeaderKey, fileId, edsCreateResponse.md5ResponseHeaderKey) });
    const edsFileMetadataResponse = yield call(createMetadata, fileMetadataRequest);
    return edsFileMetadataResponse;
};
const uploadFile = function* (fileId) {
    const fileInfo = yield select(getFileInfoById, fileId);
    let file = fileInfo.file;
    let resizedFile = file;
    if (fileInfo.maxImageSize) {
        if (isJpegImage(file.name)) {
            const originFile = fileInfo.file;
            if (originFile.type !== MimeType.APPLICATION_OCTET_STREAM) {
                resizedFile = yield call(compressImage, originFile, fileInfo.maxImageSize, fileInfo.maximumAllowedImageHeight, fileInfo.maximumAllowedImageWidth);
            }
            try {
                file = yield call(processJpegImageExif, originFile, resizedFile.name, resizedFile, fileInfo.fileDescription);
                yield put(scaleImageCompleteAction(fileInfo.id, true, file));
            }
            catch (e) {
                // when error occurs during processing JPEG image EXIF, only move forward to upload resized file without EXIF
                file = resizedFile;
                yield put(scaleImageCompleteAction(fileInfo.id, true, file));
            }
        }
        else if (fileInfo.fileName.lastIndexOf(PDF_THUMBNAIL) !== -1) {
            const image = yield call(convertPdfToImages, fileInfo.file);
            const imageFile = yield call(FileHelperService.dataURLtoFile, image, `${file.name.split('.')[0]}.png`);
            file = yield call(compressImage, imageFile, fileInfo.maxImageSize, fileInfo.maximumAllowedImageHeight, fileInfo.maximumAllowedImageWidth);
            yield put(scaleImageCompleteAction(fileInfo.id, true, file));
        }
        else {
            file = yield call(compressImage, fileInfo.file, fileInfo.maxImageSize, fileInfo.maximumAllowedImageHeight, fileInfo.maximumAllowedImageWidth);
            yield put(scaleImageCompleteAction(fileInfo.id, true, file));
        }
    }
    const edsFileMetadataResponse = yield edsUpload(fileId, fileInfo, file);
    yield put(singleFileUploadCompleteAction({
        docId: edsFileMetadataResponse.docId,
        docUID: edsFileMetadataResponse.docUID,
        uploadStatus: FileUploadStatus.SUCCESS,
        id: fileId
    }));
};
export const uploadSingleFileSaga = function* (action) {
    const fileInfo = yield select(getFileInfoById, action.payload.id);
    try {
        yield race({
            upload: call(uploadFile, fileInfo.id),
            cancel: take((cancelAction) => cancelAction.type === FILE_UPLOAD_SINGLE_FILE_UPLOAD_CANCEL &&
                (cancelAction.payload.id === fileInfo.id || cancelAction.payload.id === fileInfo.parentId))
        });
    }
    catch (e) {
        yield put(singleFileUploadCompleteAction({ uploadStatus: FileUploadStatus.FAILED, id: action.payload.id }));
    }
};
//# sourceMappingURL=uploadSingleFileSaga.js.map